module.exports = __webpack_public_path__ + "img/coin-icon.da3d30ca.svg";